import { render } from "./footer.vue?vue&type=template&id=f0f97ba6"
const script = {}

import exportComponent from "/var/www/yellowhair/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__